import React from 'react';
import { format } from 'date-fns';
import Link from 'next/link';
import { ApiRoutes } from '@/settings/routes';
import { PiSealCheckFill } from 'react-icons/pi';

function RatingDots({ rating }) {
    return (
        <div className="flex gap-0.5">
            {[1, 2, 3, 4, 5].map((n) => (
                <span key={n} className={`w-4 h-4 rounded-full ${n <= rating ? 'bg-green-600' : 'bg-gray-300'}`} />
            ))}
        </div>
    );
}

export default function Review({ content }) {
    const profileImage = content?.profile_image ? ApiRoutes.ASSETS_ENDPOINT + content.profile_image : null;

    // const formatDate = (dateString) => {
    //     if (!dateString) return '';
    //     try {
    //         const date = new Date(dateString);
    //         return format(date, 'MMM yyyy');
    //     } catch {
    //         return '';
    //     }
    // };

    return (
        <div className="py-6 border-b border-gray-200">
            <div className="flex gap-4 items-start">
                <div className="flex-shrink-0">
                    {profileImage ? (
                        <img src={profileImage} alt={content?.name} className="object-cover w-12 h-12 rounded-full" />
                    ) : (
                        <div className="flex justify-center items-center w-12 h-12 bg-gray-200 rounded-full">
                            <span className="text-lg font-semibold text-gray-500">{content?.name?.charAt(0)?.toUpperCase() || 'U'}</span>
                        </div>
                    )}
                </div>

                <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-center mb-1">
                        <div className="flex items-center gap-1.5">
                            <h4 className="font-semibold text-gray-900">{content?.name}</h4>
                            <div className="relative group">
                                <PiSealCheckFill className="text-blue-500 size-4" />
                                <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 px-3 py-1.5 bg-gray-900 text-white text-xs font-medium rounded-lg whitespace-nowrap opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-10">
                                    Verified Customer
                                    <div className="absolute top-full left-1/2 w-0 h-0 border-t-4 border-r-4 border-l-4 -translate-x-1/2 border-l-transparent border-r-transparent border-t-gray-900"></div>
                                </div>
                            </div>
                        </div>
                        {content?.url && (
                            <Link href={content.url} target="_blank" rel="noopener noreferrer" className="p-1 text-gray-400 hover:text-gray-600">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                </svg>
                            </Link>
                        )}
                    </div>

                    <div className="mb-3">
                        <RatingDots rating={content?.star_rating || 5} />
                    </div>

                    {content?.title && <h3 className="mb-1 font-bold text-gray-900">{content.title}</h3>}
                    {/* 
                    {(content?.reason || content?.travel_type) && (
                        <p className="mb-2 text-sm text-gray-500">
                            {formatDate(content?.created_at)}
                            {formatDate(content?.created_at) && (content?.reason || content?.travel_type) && ' • '}
                            {content?.travel_type || content?.reason}
                        </p>
                    )} */}

                    <p className="leading-relaxed text-gray-700">{content?.comment}</p>

                    {content?.images?.length > 0 && (
                        <div className="flex flex-wrap gap-2 mt-4">
                            {content.images.slice(0, 4).map((img, index) => (
                                <img key={img.id || index} src={ApiRoutes.ASSETS_ENDPOINT + img.url} alt="" className="object-cover w-20 h-20 rounded-lg" />
                            ))}
                            {content.images.length > 4 && (
                                <div className="flex justify-center items-center w-20 h-20 text-sm font-medium text-gray-500 bg-gray-100 rounded-lg">+{content.images.length - 4}</div>
                            )}
                        </div>
                    )}

                    {content?.url && (
                        <Link href={content.url} target="_blank" rel="noopener noreferrer" className="inline-flex gap-1 items-center mt-3 text-sm font-medium text-main-color hover:text-green-700">
                            Read full review on TripAdvisor
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
}
